import { DispoUser } from '../../models/user';
import { Employment } from '../../models/employment';
import { getReadDepartmentIds } from '../../../helpers/permissions/departmentPermissions';

export function getEmploymentDispoDepartmentQuery(
  disponent: DispoUser,
): Mongo.Selector<Employment> {
  if (
    !disponent.dispoPermissions.departments?.specificDepartmentIds ||
    disponent.dispoPermissions.departments?.readAll
  ) {
    return {};
  }
  let departmentIds = getReadDepartmentIds(
    disponent.dispoPermissions.departments,
  );
  return {
    'department.id': {
      $in: departmentIds,
    },
  };
}
